import Modal from "../../../../components/Modal";
import "react-toastify/dist/ReactToastify.css";

const PostingBonus = (props) => {
  const activeModal = props.activeModal ? "effect-scale show" : "";
  const activeStyle = activeModal ? { display: "block", paddingright: "17px" } : "";

  const submitHandler = () => {
    props.onConfirm();
    props.closeModal();
  };

  return (
    <Modal
      activeModal={activeModal}
      activeStyle={activeStyle}
      title="Alert Bonus - Posting to Complain Close"
      closeClick={props.closeModal}
      submitHandler={submitHandler}
      type="Ya, Posting"
    >
      <h5>Proses ini akan menyatukan data tukang dalam satu periode</h5>
      <h5 className="mt-4 fw-bold">Apakah anda yakin ?</h5>
    </Modal>
  );
};

export default PostingBonus;
